import {getMenu} from "@/apis/auth";
import store from "@/store";


const menuFilter = function (list = [], allRoles = []) {
    let menu = list.filter(item => {
        let isHas = false
        const {id,meta: {roles = []}, children} = item
        isHas = roles.some(temp => {
            return allRoles.includes(temp) > 0
        })
        return isHas
    })
    return menu.map(item => {
        const obj = item
        if (item.children) {
            const child = menuFilter(item.children, allRoles)
            obj.children = child
        }
        return obj
    })
}

const checkHandle = function (list, checkPath) {
    let flag = false
    list&&list.forEach(item => {
        if(item.path === checkPath) {
            flag = true
        } else if(item.children && item.children.length) {
            flag = checkHandle(item.children, checkPath)
        }
    })
    return flag
}
export default {
    data () {

    },
    methods: {
        //  获取按钮,
        getMenu: async function (allRoles) {
            const that = this
            getMenu().then(({code, data}) => {
                if (code === 0) {
                    const wmsModel = data.reduce((pre, item) => {
                        return item.name === 'WMS' ? item : pre
                    }, {})
                    let wmsMenu = []
                    if (wmsModel.children && wmsModel.children.length) {
                        wmsMenu = menuFilter(wmsModel.children, allRoles).map((item, index) => {
                            return {
                                ...item,
                                isActive: index === 0
                            }
                        })
                        store.dispatch('menu/setMenu', wmsMenu).then(r => {
                            that.headerActiveRe(that.$route)
                        }) // 生成导航
                    }
                }
            })
        },
        // 刷新页面后，重新检索激活 header Nav 中对应的 item
        headerActiveRe: async function (newVal) {
            let activeObj = store.getters.getMenus.reduce((pre, item) => {
                return item.isActive ? item : pre
            }, null)

            const nowPath = newVal.path
            let activeIsTrue = true
            if(!activeObj) {
                return
            }
            let navItem = {}
            store.getters.getMenus.forEach(item => {
                if(checkHandle(item.children, nowPath)) {
                    navItem = item
                }
            })
           await store.dispatch('menu/changeMenu', navItem)
        }
    }
}